/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';
import { AxiosInstance } from 'axios';

export interface IMemberships {
    getSettings(cancelToken?: CancelToken): AxiosPromise<MembershipsSettings>;
    getRecurringServiceSettings(
        cancelToken?: CancelToken
    ): AxiosPromise<MembershipsRecurringServicesSettings>;
    getMemberships(cancelToken?: CancelToken): AxiosPromise<MembershipsCustomer[]>;
    membershipsExist(cancelToken?: CancelToken): AxiosPromise<boolean>;
    getMembershipDetail(id: number, cancelToken?: CancelToken): AxiosPromise<MembershipDetail>;
    getEquipmentServiceHistorySummary(
        installedEquipmentId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<EquipmentServiceHistoryItem[]>;
    setMembershipPreferredPaymentMethod(
        id: number,
        request: SetMembershipPreferredPaymentMethodRequest,
        cancelToken?: CancelToken
    ): AxiosPromise<void>;
}

export const BASE_URL_TOKEN_Memberships = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class Memberships implements IMemberships {
    private baseUrl = '';
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private axios: AxiosInstance) {}

    getSettings(cancelToken?: CancelToken): AxiosPromise<MembershipsSettings> {
        let url_ = '/v1/customerportal2/memberships/settings';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<MembershipsSettings>(options_));
    }

    getRecurringServiceSettings(
        cancelToken?: CancelToken
    ): AxiosPromise<MembershipsRecurringServicesSettings> {
        let url_ = '/v1/customerportal2/memberships/settings/recurringservices';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(
            this.axios.request<MembershipsRecurringServicesSettings>(options_)
        );
    }

    getMemberships(cancelToken?: CancelToken): AxiosPromise<MembershipsCustomer[]> {
        let url_ = '/v1/customerportal2/memberships';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<MembershipsCustomer[]>(options_));
    }

    membershipsExist(cancelToken?: CancelToken): AxiosPromise<boolean> {
        let url_ = '/v1/customerportal2/memberships/exists';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<boolean>(options_));
    }

    getMembershipDetail(id: number, cancelToken?: CancelToken): AxiosPromise<MembershipDetail> {
        let url_ = '/v1/customerportal2/memberships/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<MembershipDetail>(options_));
    }

    getEquipmentServiceHistorySummary(
        installedEquipmentId: number,
        cancelToken?: CancelToken
    ): AxiosPromise<EquipmentServiceHistoryItem[]> {
        let url_ = '/v1/customerportal2/memberships/equipmenthistory/{installedEquipmentId}';
        if (installedEquipmentId === undefined || installedEquipmentId === null)
            throw new Error("The parameter 'installedEquipmentId' must be defined.");
        url_ = url_.replace(
            '{installedEquipmentId}',
            encodeURIComponent('' + installedEquipmentId)
        );
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<EquipmentServiceHistoryItem[]>(options_));
    }

    setMembershipPreferredPaymentMethod(
        id: number,
        request: SetMembershipPreferredPaymentMethodRequest,
        cancelToken?: CancelToken
    ): AxiosPromise<void> {
        let url_ = '/v1/customerportal2/memberships/{id}/paymentmethod';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<void>(options_));
    }
}

export interface MembershipsSettings {
    enabled: boolean;
    nameType: MembershipNameType;
}

export enum MembershipNameType {
    Membership = 0,
    Contract = 1,
}

export interface MembershipsRecurringServicesSettings {
    recurringServiceEventMessage?: string | undefined;
}

export interface MembershipsCustomer {
    id: number;
    name: string;
    address: string;
    locations: MembershipsLocation[];
    allLocationsMemberships: MembershipSummary[];
}

export interface MembershipsLocation {
    id: number;
    customerId: number;
    name: string;
    address: string;
    memberships: MembershipSummary[];
    recurringServicesEquipment: MembershipEquipmentModel[];
    equipmentAssets: MembershipEquipmentAsset[];
}

export interface MembershipSummary {
    id: number;
    customerId: number;
    locationId?: number | undefined;
    name: string;
    status: MembershipStatus;
    duration?: number | undefined;
    billingFrequency: MembershipRecurrenceType;
    from?: Date | undefined;
    to?: Date | undefined;
    nextBillingDate?: Date | undefined;
    isAllLocations: boolean;
    isRenewed: boolean;
    visitsDue: boolean;
    createdOn: Date;
}

export enum MembershipStatus {
    Active = 0,
    Suspended = 1,
    Expired = 2,
    Canceled = 3,
    Deleted = 4,
}

export enum MembershipRecurrenceType {
    OneTime = 0,
    Monthly = 1,
    EveryOtherMonth = 2,
    Quarterly = 3,
    BiAnnual = 6,
    Annual = 12,
}

export interface MembershipEquipmentBaseModel {
    equipmentId: number;
    name?: string | undefined;
    active: boolean;
    model?: string | undefined;
    manufacturer?: string | undefined;
    type?: string | undefined;
    serialNumber?: string | undefined;
    memo?: string | undefined;
    membershipIds?: number[] | undefined;
    locationId: number;
    installedOn?: Date | undefined;
    manufacturerWarrantyStart?: Date | undefined;
    manufacturerWarrantyEnd?: Date | undefined;
    serviceProviderWarrantyStart?: Date | undefined;
    serviceProviderWarrantyEnd?: Date | undefined;
    equipmentSkuId?: number | undefined;
}

export interface MembershipEquipmentModel extends MembershipEquipmentBaseModel {
    recurringServices?: MembershipEquipmentRecurringServiceModel[] | undefined;
    tags?: TagModel[] | undefined;
    customFieldValues?: string[] | undefined;
}

export interface MembershipEquipmentRecurringServiceModel {
    id: number;
    name: string;
    locationId: number;
}

export interface TagModel {
    id: number;
    ownerId: number;
    typeId: number;
    typeName?: string | undefined;
    memo?: string | undefined;
    color?: string | undefined;
    textColor?: string | undefined;
    code?: string | undefined;
    importance?: string | undefined;
    isVisibleOnDispatchBoard: boolean;
    projectedValueAdjustment: number;
}

export interface MembershipEquipmentAsset {
    equipmentId: number;
    photoUrls: string[];
}

export interface MembershipDetail {
    customerId: number;
    customerName: string;
    customerAddress: string;
    name: string;
    status: MembershipStatus;
    duration?: number | undefined;
    billingFrequency: MembershipRecurrenceType;
    from?: Date | undefined;
    to?: Date | undefined;
    nextBillingDate?: Date | undefined;
    nextBillingAmount?: number | undefined;
    paymentId?: number | undefined;
    paymentNumber?: string | undefined;
    paymentType?: PaymentTypeMethod | undefined;
    locations: MembershipDetailLocation[];
    visits: MembershipDetailVisit[];
    servicedEquipment: MembershipEquipmentModel[];
    equipmentAssets: MembershipEquipmentAsset[];
    invoices: MembershipDetailInvoice[];
    isAllLocations: boolean;
    isSingleRecurringLocation: boolean;
    isRenewed: boolean;
    visitsDue: boolean;
}

export enum PaymentTypeMethod {
    None = 0,
    CreditCard = 1,
    BankAccount = 2,
    Cash = 3,
    Check = 4,
    Mrdc = 5,
    GreenSkyDirectFunding = 6,
}

export interface MembershipDetailLocation {
    name: string;
    address: string;
}

export interface MembershipDetailVisit {
    description: string;
    isCompleted: boolean;
    invoiceDate?: Date | undefined;
    invoiceId?: string | undefined;
    jobStatus?: JobStatus | undefined;
}

export enum JobStatus {
    Scheduled = 0,
    Dispatched = 1,
    InProgress = 2,
    Hold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface MembershipDetailInvoice {
    id: string;
    number: string;
    invoicedOn?: Date | undefined;
    total: number;
    balance: number;
    invoiceType: string;
}

export interface EquipmentServiceHistoryItem {
    invoiceId: string;
    invoiceNumber?: string | undefined;
    technicians: string[];
    service?: string | undefined;
    material?: string | undefined;
    description: string;
    date: Date;
}

export interface SetMembershipPreferredPaymentMethodRequest {
    paymentMethodId: number;
}
